import { render, staticRenderFns } from "./SparePartTabDialog.vue?vue&type=template&id=bedb27a4"
import script from "./SparePartTabDialog.vue?vue&type=script&lang=ts"
export * from "./SparePartTabDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports